export default "__VITE_ASSET__bd766bc9__"